import { ConfigurationFieldType, EntityListResponse } from '@ydistri/api-sdk';
import { useCategoryConfiguration } from '../../../../../hooks/useCategoryConfiguration';
import {
  getDefaultEntityListsParams,
  useGetEntityListsQuery,
} from '../../../../ProjectAdministration/EntityListAdministration/apiEntityLists';
import { useCallback } from 'react';
import { getConfiguredEntityLists } from './entityListLib';

export type GetConfiguredEntityLists = (fieldType: ConfigurationFieldType) => EntityListResponse[];

/**
 * Returns a function that provides the configured entity lists for a given configuration field type in the specified category.
 * @param categoryId - The ID of the category to retrieve configured entity lists for.
 * @returns A function that takes a ConfigurationFieldType and returns an array of EntityListResponse objects.
 */
const useConfiguredEntityLists = (categoryId: number): GetConfiguredEntityLists => {
  const { rootCategoryConfiguration } = useCategoryConfiguration(categoryId);

  const { data: entityLists, isFetching: isFetchingEntityLists } = useGetEntityListsQuery(
    getDefaultEntityListsParams(),
  );

  return useCallback(
    (configurationField: ConfigurationFieldType) => {
      if (isFetchingEntityLists || !rootCategoryConfiguration || !entityLists) return [];

      return getConfiguredEntityLists(configurationField, rootCategoryConfiguration, entityLists);
    },
    [entityLists, isFetchingEntityLists, rootCategoryConfiguration],
  );
};

export default useConfiguredEntityLists;
